import { render, staticRenderFns } from "./TicketImage.vue?vue&type=template&id=14db5888&scoped=true"
import script from "./TicketImage.vue?vue&type=script&lang=js"
export * from "./TicketImage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14db5888",
  null
  
)

export default component.exports